import { use, useEffect, useState } from "react";
import { usePlan } from "../_providers/PlanProvider";
import Item from "../models/Transaction";
import "./Transaction.css";

const Transaction = (props: {item: Item, onDelete?: (uid: string) => void}) => {
    const [person, setPerson] = useState<{displayName: string} | null>(null);
    const transaction = props.item;
    const {selectedPlan} = usePlan();

    const desc = transaction.description
    const date = transaction.date.toDate();
    const amount = transaction.amount
    const recurrence = transaction.recurrance
    useEffect(() => {
        if (!selectedPlan) {
            console.error("No plan selected");
            return;
        }
        const person = selectedPlan.users.find((user) => user.uid === transaction.user_id);
        console.log(selectedPlan.users, transaction.user_id);
        setPerson(person || {displayName: "Unknown User"});
    }, [selectedPlan, transaction.user_id]);

    return (
        <div className="transaction dark">
            <p className="desc">{desc}</p>
            <p className="amount">{amount.toLocaleString("nl-NL", {style: "currency", currency: "EUR"})}</p>
            <p className="date">{date.toLocaleDateString("nl-NL", {day: "numeric", month: "long", year: "numeric"})}</p>
            <p className="date">{person?.displayName}</p>
            {recurrence ? (
                <p className="reccurence">Recurs every {recurrence.value == 1 ? "" : recurrence.value} {recurrence.value == 1 ? "month" : recurrence.type} {recurrence.end_date ? `until ${recurrence.end_date.toDate().toLocaleDateString("nl-NL", {day: "numeric", month: "long", year: "numeric"})}` : ""}</p>
            ) : <p className="reccurence">No recurrence</p>}
            {props.onDelete !== undefined ? <p className="inline_btn" onClick={() => props.onDelete?.(props.item.uid)}><i className="fa-solid fa-trash"></i></p> : null}
        </div>
    );
}
export default Transaction;